import { apiRequest } from './index';

export const fetchAreaRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/areas/' + id, {}, success, failure);
}

export const fetchAreasRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/areas', {}, success, failure);
}

export const createAreaRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/areas',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editAreaRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/areas/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

const buildAreaOptions = area => ({
    value: area ? area._id : '',
    label: area ? area.areaName : '',
    data: area
});

export const areaSelectOptionRequest = (success = (result = []) => {}, failure = (error) => {}) =>{
    fetch(process.env.REACT_APP_API_ENDPOINT + '/areas')
        .then(response => response.json())
        .then(data => {
            const selectOptions = [];
            data.forEach((item) => {
                const option = buildAreaOptions(item);
                selectOptions.push(option);
            });
            success(selectOptions);
        })
        .catch(error =>{
            failure(error.status);
        });
}

export const deleteAreaRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/areas/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
